import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-new-folder-model',
  templateUrl: './new-folder-model.component.html',
  styleUrls: ['./new-folder-model.component.scss']
})
export class NewFolderModelComponent implements OnInit, DwModalHandler{
  FileName: string;

  constructor() { }
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;
  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    const result: DwModalResult = new DwModalResult();
    result.closeModal = true;
    result.cancelled = false;
    if (buttonConfig.command == DwButtonCommand.cancel)
    {
      result.cancelled = true;
    }
    else{
    result.data = this.FileName;}

    return of(result);
  }

  ngOnInit(): void {
  }
  onFileName(fileName: string){
    this.FileName = fileName;
  }

}
